const contentSorting = {
  recommendedDesc: {
    displayName: 'Recommended first',
    field: 'isInProgress',
    order: 'desc'
  },
  modifiedDateDesc: {
    displayName: 'Newest first',
    field: 'publicationDate',
    order: 'desc'
  },
  modifiedDateAsc: {
    displayName: 'Oldest first',
    field: 'publicationDate',
    order: 'asc'
  },
  cpdPointsDesc: {
    displayName: 'Most CPD hours first',
    field: 'cpdPoints',
    order: 'desc'
  },
  cpdPointsAsc: {
    displayName: 'Least CPD hours first',
    field: 'cpdPoints',
    order: 'asc'
  },
  readingTimeAsc: {
    displayName: 'Low reading time first',
    field: 'estimatedReadingTime',
    order: 'asc'
  },
  readingTimeDesc: {
    displayName: 'High reading time first',
    field: 'estimatedReadingTime',
    order: 'desc'
  }
};

export default contentSorting;



// WEBPACK FOOTER //
// ./src/constants/content-sorting.js